export const isEnvExist = (env?: string) => {
	return Boolean(env && !env.startsWith('PLACEHOLDER-'));
};
